import apiClient from './client'
import type { Group, CreateGroupRequest, UpdateGroupRequest } from '@/types'

export interface DesktopScheduleSlot { day_of_week: number; start_time: string; end_time: string; location?: string }
export interface DesktopSchedulePreview {
  from: string; changed: boolean; kept_marked: number
  base?: { schedule: DesktopScheduleSlot[] | null } | null
  items?: { date: string; change: string; marks: number; outcome: string }[] | null
  delete_session_ids?: string[] | null
  replace_version_ids?: string[] | null
  suggested_from?: string | null
}
export const groupsApi = {
  previewSchedule: async (id: string, schedule: DesktopScheduleSlot[], from: string): Promise<DesktopSchedulePreview> => {
    const { data } = await apiClient.post(`/groups/${id}/schedule/preview`, { schedule, from })
    return data
  },
  replaceSchedule: async (id: string, schedule: DesktopScheduleSlot[], preview: DesktopSchedulePreview): Promise<void> => {
    await apiClient.put(`/groups/${id}/schedule`, { schedule, from: preview.from, expected_schedule: preview.base?.schedule || [], delete_session_ids: preview.delete_session_ids || [], replace_version_ids: preview.replace_version_ids || [] })
  },
  getByAssistantId: async (assistantId: string): Promise<Group[]> => {
    const { data } = await apiClient.get(`/assistants/${assistantId}/groups`)
    return data
  },

  getById: async (_assistantId: string, id: string): Promise<Group> => {
    const { data } = await apiClient.get(`/groups/${id}`)
    return data
  },

  create: async (assistantId: string, req: CreateGroupRequest): Promise<Group> => {
    const { data } = await apiClient.post(`/assistants/${assistantId}/groups`, req)
    return data
  },

  update: async (_assistantId: string, id: string, req: UpdateGroupRequest & { clear_description?: boolean }): Promise<Group> => {
    const { data } = await apiClient.put(`/groups/${id}`, req)
    return data
  },

  delete: async (_assistantId: string, id: string): Promise<void> => {
    await apiClient.delete(`/groups/${id}`)
  },

  addAthlete: async (_assistantId: string, groupId: string, athleteId: string): Promise<void> => {
    await apiClient.post(`/athletes/${athleteId}/assign-group`, { group_id: groupId })
  },

  removeAthlete: async (_assistantId: string, _groupId: string, athleteId: string): Promise<void> => {
    await apiClient.post(`/athletes/${athleteId}/remove-group`)
  },
}
